import React from "react"
import { useState } from "react"
import { useDispatch } from "react-redux"

import { TextArea } from "../../../../components/DesignSystem"
import Button from "../../../../components/DesignSystem/Button"
import Checkbox from "../../../../components/DesignSystem/Checkbox"

import SectionHeader from "../SectionHeader"

import "./index.scss"

const negotiationOptions = [
  { value: "PAYMENT_TERMS", label: "Condição de pagamento" },
  { value: "VALUE", label: "Valor" },
  { value: "CAN_NOT_AFFORD", label: "Não posso pagar" },
]

export default function ReasonToReject({ handleChangeStep }) {
  const [selectedOptions, setSelectedOptions] = useState([])
  const [comment, setComment] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()

  function handleGoBack() {
    handleChangeStep(1)
  }

  function handleSubmit(event) {
    event.preventDefault()
    setIsLoading(true)
    setTimeout(() => {
      dispatch({ type: "CHANGE_DEBT_INFO", payload: { status: "ARCHIVED" } })
      dispatch({
        type: "CHANGE_SUCCESS_MESSAGE",
        payload: {
          title: "Proposta rejeitada com sucesso",
          hasButton: true,
          type: "REJECT_PROPOSAL",
        },
      })
      handleChangeStep(5)
      setIsLoading(false)
    }, 2000)
  }

  function handleChangeOptions(event) {
    const value = event.target.dataset.value

    if (selectedOptions.includes(value)) {
      setSelectedOptions((selectedOptions) =>
        selectedOptions.filter((selectedOption) => selectedOption !== value),
      )
    } else {
      setSelectedOptions([...selectedOptions, value])
    }
  }

  return (
    <div className="reason-reject">
      <SectionHeader handleGoBack={handleGoBack}>
        <h2>Por quais motivos você rejeita as propostas?</h2>
      </SectionHeader>
      <section>
        <form className="reason-reject__form" onSubmit={handleSubmit}>
          <div>
            {negotiationOptions.map((negotiationOption) => (
              <div
                className="reason-reject__checkbox"
                onClick={handleChangeOptions}
                data-value={negotiationOption.value}
                key={negotiationOption.value}
              >
                <div>
                  <Checkbox
                    checked={selectedOptions.includes(negotiationOption.value)}
                  />
                  <label>{negotiationOption.label}</label>
                </div>
              </div>
            ))}
          </div>
          <div>
            <TextArea
              value={comment}
              onChange={(value) => setComment(value)}
              placeholder="Adicione um comentário... (opcional)"
            />
          </div>

          <Button
            size="small"
            contained
            type="submit"
            icon="ArrowRight"
            iconRight
            sizeIcon={16}
            disabled={selectedOptions.length === 0}
            loading={isLoading}
          >
            Continuar
          </Button>
        </form>
      </section>
    </div>
  )
}
